var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.122 11.783h10.095a.56.56 0 0 0 .535-.403l2.226-7.793a.557.557 0 0 0-.535-.71H3.838l-.398-1.79A.56.56 0 0 0 2.896.65H.556a.557.557 0 1 0 0 1.114H2.45l2.01 9.044a1.67 1.67 0 0 0-1.007 1.532c0 .92.75 1.67 1.67 1.67h10.094a.557.557 0 0 0 0-1.114H5.123a.557.557 0 0 1-.001-1.113M16.705 3.99l-1.908 6.68H5.57L4.085 3.99zM4.566 15.68c0 .92.75 1.67 1.67 1.67.921 0 1.67-.75 1.67-1.67 0-.921-.749-1.67-1.67-1.67s-1.67.749-1.67 1.67m1.67-.557a.557.557 0 1 1-.001 1.115.557.557 0 0 1 .001-1.115M12.434 15.68c0 .92.749 1.67 1.67 1.67s1.67-.75 1.67-1.67c0-.921-.75-1.67-1.67-1.67-.921 0-1.67.749-1.67 1.67m1.67-.557a.557.557 0 1 1-.002 1.115.557.557 0 0 1 .002-1.115"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M6.75 3.5v8m6.906-7.732v8M4.5 7.35h12M10.25 3.5v8"
  })));
};
export default SvgCart;